import { Title } from '@solidjs/meta'
import type { Component } from 'solid-js'
import Button from '~/components/Button'
import Card from '~/components/Card'
import Container from '~/components/Container'
import Icon from '~/components/Icon'
import { useAuth } from '~/contexts/AuthContext'
import { useNavigate } from '~/router'

/**
 * Pantalla de espera para usuarios sin empresa asignada.
 *
 * Un usuario recién registrado (por ejemplo con Google) entra sin pertenecer a
 * ninguna empresa. Puede iniciar sesión y ver su perfil, pero nada más: las
 * demás secciones requieren empresa activa y el backend las rechaza con 403
 * (`requireCompany`). Hasta que un administrador o root le asigne una empresa,
 * esta es su única pantalla.
 */
const EsperandoEmpresaPage: Component = () => {
  const navigate = useNavigate()
  const auth = useAuth()

  const handleLogout = async () => {
    await auth.logout()
    navigate('/login', { replace: true })
  }

  return (
    <>
      <Title>Cuenta pendiente | Florez Jaramillo</Title>
      <Container class="min-h-full py-10">
        <div class="mx-auto max-w-md">
          <Card>
            <Card.Body>
              <div class="text-center py-6">
                <div class="mx-auto mb-4 flex size-16 items-center justify-center rounded-full bg-warning-soft text-warning">
                  <Icon icon="material-symbols-light:hourglass-top" size={36} />
                </div>
                <h1 class="text-xl font-bold text-foreground">Tu cuenta está pendiente de asignación</h1>
                <p class="mt-2 text-sm text-foreground-subtle leading-relaxed">
                  Aún no estás vinculado a ninguna empresa. Mientras tanto puedes editar tu perfil. Un administrador debe asignarte una empresa para acceder al panel.
                </p>
              </div>

              <div class="flex flex-col gap-2 border-t border-border pt-4">
                <Button color="primary" onClick={() => navigate('/admin/perfil')} prependIcon="material-symbols-light:person-outline" fullWidth>
                  Editar mi perfil
                </Button>
                <Button variant="soft" color="default" onClick={handleLogout} prependIcon="material-symbols-light:logout" fullWidth>
                  Cerrar sesión
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </>
  )
}

export default EsperandoEmpresaPage
